import { Message } from '@arco-design/web-vue'
import axios from '@fe/zxwy-utils/tool/axios'
import { getUserInfo as getUserInfoByUtils } from '@fe/zxwy-utils/api/user'
import { logout as logoutByUtils } from '@fe/zxwy-utils/api/system'
import { getDicts as getDictsByUtils } from '@fe/zxwy-utils/api/dicts'

import { usePermissionStore } from '@/store/modules/permission'

const service = axios(process.env.NODE_ENV)

const request = (config) => {
  return service(config).catch(error => {
    if(error.code === 400) {
      Message.error({ content: error.toString(), duration: 6000 })
    }
    else if (error.code !== 401) {
      Message.error({ content: error.Message, duration: 6000 })
    }
    else {
      Message.error('认证失败，无法访问系统资源')
      usePermissionStore().logout()
    }
    return Promise.reject(error)
  })
}

export const uploadOSS = (params, file, config) => {
  return service.uploadOSS(params, file, config).catch((error) => {
    Message.error({ content: '上传文件出现错误，请联系管理员！', duration: 6000 })
    return Promise.reject(error)
  })
}

export const logout = (...arg) => logoutByUtils(request, ...arg)

export const getUserInfo = (...arg) => getUserInfoByUtils(request, ...arg)

export const getDicts = (...arg) => getDictsByUtils(request, ...arg)

export default request

